/**
 * @module web/util/subject-options
 * @description The canonical list of subjects a teacher can pick when
 * creating or editing a class. Was hardcoded separately in
 * create-class-overlay.tsx and rename-class-overlay.tsx -- both currently
 * agree, by design (rename-class-overlay.tsx was built to match
 * create-class-overlay.tsx's values), but with no shared source of truth,
 * which is exactly the shape the deriveGradeBand duplication bug started
 * as. Flagged in today's Lego-alignment audit.
 */
export const SUBJECT_OPTIONS = ['Science', 'Math', 'ELA', 'Social Studies', 'Other']
